module.exports = __webpack_public_path__ + "img/right.a70237dd.png";